import { Grid, Typography } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import ProductEditDialog from "pages/products/menu/ProductEditDialog";
import ProductImageInDialog from "pages/products/menu/ProductImageInDialog";
import ProductMenu from "pages/products/menu/ProductMenu";
import ProductOfferDialog from "pages/products/menu/ProductOfferDialog";
import ProductVariantsInDialog from "pages/products/menu/ProductVariantsInDialog";
import ProductVideoInDialog from "pages/products/menu/ProductVideoInDialog";
import ProductItem from "pages/products/ProductItem";
import ValidationAllocationDialog from "pages/product_validation/validationAllocation/menu/ValidationAllocationDialog";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteProductsThunk } from "store/reducers/product/productSlice";
import ProductGstDialog from "./gst/ProductGstDialog";

const ProductsList = ({ products }) => {
  const dispatch = useDispatch();
  const { loading, error, errorMessage, success } = useSelector(
    (state) => state.product
  );
  const drawerOpen = useSelector((state) => state.menu.drawerOpen);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [contextMenu, setContextMenu] = React.useState(null);
  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setContextMenu(null);
  };
  const [currentItem, setCurrentItem] = React.useState(null);
  const handleContextMenu = (event, item) => {
    event.preventDefault();
    setCurrentItem(item);
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );
  };
  const [openImageUpdate, setOpenImageUpdate] = React.useState(false);
  const handleImageClose = () => {
    setOpenImageUpdate(false);
  };

  const [openProductUpdate, setOpenProductUpdate] = React.useState(false);
  const handleProductClose = () => {
    setOpenProductUpdate(false);
  };

  const [openVideoUpdate, setOpenVideoUpdate] = React.useState(false);
  const handleVideoClose = () => {
    setOpenVideoUpdate(false);
  };

  const [openVariantUpdate, setOpenVariantUpdate] = React.useState(false);
  const handleVariantClose = () => {
    setOpenVariantUpdate(false);
  };

  const [openGstDialog, setOpenGstDialog] = React.useState(false);
  const handleGstClose = () => {
    setOpenGstDialog(false);
  };

  const onGstClick = (product) => {
    setCurrentItem(product);
    setOpenGstDialog(true);
  };

  const [openOfferDialog, setOpenOfferDialog] = React.useState(false);
  const handleOfferClose = () => {
    setOpenOfferDialog(false);
  };

  const [openValidationAllocationDialog, setOpenValidationAllocationDialog] =
    React.useState(false);
  const handleValidationAllocationClose = () => {
    setOpenValidationAllocationDialog(false);
  };

  const removeProduct = () => {
    dispatch(deleteProductsThunk(currentItem.id));
  };

  return (products.length === 0) & !loading?.list ? (
    <Typography variant="overline" color="text.secondary" sx={{ mt: 3 }}>
      No subcategories in this selection
    </Typography>
  ) : (
    <>
      {!loading?.list && (
        <Grid container spacing={1} marginTop={1}>
          {products.map((product) => (
            <Grid
              item
              xl={3}
              lg={drawerOpen ? 6 : 3}
              md={6}
              xs={12}
              key={product.id}
            >
              <ProductItem
                product={product}
                handleClick={handleClick}
                handleContextMenu={handleContextMenu}
                openGstDialog={onGstClick}
              />
            </Grid>
          ))}
        </Grid>
      )}
      <ProductMenu
        context={true}
        product={currentItem}
        anchorEl={anchorEl}
        handleClose={handleClose}
        contextMenu={contextMenu}
        setOpenImageUpdate={setOpenImageUpdate}
        setOpenVideoUpdate={setOpenVideoUpdate}
        setOpenVariantUpdate={setOpenVariantUpdate}
        setOpenOfferDialog={setOpenOfferDialog}
        setOpenValidationAllocationDialog={setOpenValidationAllocationDialog}
        setOpenProductUpdate={setOpenProductUpdate}
        removeProduct={removeProduct}
      />
      <ProductMenu
        context={false}
        product={currentItem}
        anchorEl={anchorEl}
        handleClose={handleClose}
        contextMenu={contextMenu}
        setOpenImageUpdate={setOpenImageUpdate}
        setOpenVideoUpdate={setOpenVideoUpdate}
        setOpenVariantUpdate={setOpenVariantUpdate}
        setOpenOfferDialog={setOpenOfferDialog}
        setOpenValidationAllocationDialog={setOpenValidationAllocationDialog}
        setOpenProductUpdate={setOpenProductUpdate}
        removeProduct={removeProduct}
      />
      {currentItem && (
        <ProductImageInDialog
          open={openImageUpdate}
          handleClose={handleImageClose}
          product={currentItem}
        />
      )}

      {currentItem && (
        <ProductVideoInDialog
          open={openVideoUpdate}
          handleClose={handleVideoClose}
          product={currentItem}
        />
      )}

      {currentItem && (
        <ProductVariantsInDialog
          open={openVariantUpdate}
          handleClose={handleVariantClose}
          product={currentItem}
        />
      )}

      {currentItem && (
        <ProductOfferDialog
          open={openOfferDialog}
          handleClose={handleOfferClose}
          product={currentItem}
        />
      )}

      {currentItem && (
        <ValidationAllocationDialog
          open={openValidationAllocationDialog}
          handleClose={handleValidationAllocationClose}
          product={currentItem}
        />
      )}

      {currentItem && (
        <ProductEditDialog
          open={openProductUpdate}
          handleClose={handleProductClose}
          product={currentItem}
        />
      )}

      {currentItem && (
        <ProductGstDialog
          open={openGstDialog}
          handleClose={handleGstClose}
          product={currentItem.id}
          gst={currentItem.gst}
        />
      )}
    </>
  );
};

export default ProductsList;
